import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificacionRoutingModule } from './notificacion-routing.module';
import { ComponentsModule } from 'src/app/components/components.module';
import { PI_MODULES } from '../base/prime-modules';
import { ContactoVentanaComponent } from './contacto/contacto-ventana/contacto-ventana.component';
import { ContactoListaComponent } from './contacto/contacto-lista/contacto-lista.component';
import { EnviarCorreoComponent } from './procesos/enviar-correo/enviar-correo.component';
import { HistorialNotificacionListaComponent } from './historial-notificacion/historial-notificacion-lista/historial-notificacion-lista.component';
import { HistorialNotificacionVentanaComponent } from './historial-notificacion/historial-notificacion-ventana/historial-notificacion-ventana.component';
import { InformeNotificacionComponent } from './reportes/informe-notificacion/informe-notificacion.component';
import { ImportarContactoComponent } from './procesos/importar-contacto/importar-contacto.component';
import { EnvioMensajeComponent } from './procesos/envio-mensaje/envio-mensaje.component';
import { WhatsappConversationActionsComponent } from './whatsapp-conversation/components/whatsapp-conversation-actions/whatsapp-conversation-actions.component';
import { WhatsappConversationTimelineComponent } from './whatsapp-conversation/components/whatsapp-conversation-timeline/whatsapp-conversation-timeline.component';
import { WhatsappConversationListaComponent } from './whatsapp-conversation/whatsapp-conversation-lista/whatsapp-conversation-lista.component';
import { WhatsappConversationVentanaComponent } from './whatsapp-conversation/whatsapp-conversation-ventana/whatsapp-conversation-ventana.component';
import { WhatsappTemplateListaComponent } from './whatsapp-template/whatsapp-template-lista/whatsapp-template-lista.component';
import { WhatsappTemplateVentanaComponent } from './whatsapp-template/whatsapp-template-ventana/whatsapp-template-ventana.component';
import { ChartModule } from 'primeng/chart';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlujoEditorComponent } from './whatsapp-template/whatsapp-template-ventana/components/flujo/flujo-editor.component';
import { FlujoNodoListaComponent } from './whatsapp-template/whatsapp-template-ventana/components/flujo/components/flujo-nodo-lista/flujo-nodo-lista.component';
import { FlujoNodoComponent } from './whatsapp-template/whatsapp-template-ventana/components/flujo/components/flujo-nodo/flujo-nodo.component';
import { FlujoNodoEditorComponent } from './whatsapp-template/whatsapp-template-ventana/components/flujo/components/flujo-nodo-editor/flujo-nodo-editor.component';
import { FlujoValidacionPanelComponent } from './whatsapp-template/whatsapp-template-ventana/components/flujo/components/flujo-validacion-panel/flujo-validacion-panel.component';
import { FlujoAyudaComponent } from './whatsapp-template/whatsapp-template-ventana/components/flujo/components/flujo-ayuda/flujo-ayuda.component';



@NgModule({
  declarations: [
    ContactoVentanaComponent,
    ContactoListaComponent,
    EnviarCorreoComponent,
    HistorialNotificacionListaComponent,
    HistorialNotificacionVentanaComponent,
    InformeNotificacionComponent,
    ImportarContactoComponent,
    EnvioMensajeComponent,
    WhatsappConversationActionsComponent,
    WhatsappConversationTimelineComponent,
    WhatsappConversationListaComponent,
    WhatsappConversationVentanaComponent,
    WhatsappTemplateListaComponent,
    WhatsappTemplateVentanaComponent,
    FlujoEditorComponent,
    FlujoNodoListaComponent,
    FlujoNodoComponent,
    FlujoNodoEditorComponent,
    FlujoValidacionPanelComponent,
    FlujoAyudaComponent,
  ],
  imports: [
    CommonModule,
    NotificacionRoutingModule,
    ComponentsModule,
    ...PI_MODULES,
    ChartModule,
    DragDropModule
  ]
})
export class NotificacionModule { }
